import { useQuery } from "@tanstack/react-query";
import {
  sanityClient,
  galleryPageQuery,
  type Gallery,
} from "../sanity";

export function useGallery() {
  return useQuery({
    queryKey: ["gallery"],
    queryFn: () => sanityClient.fetch<Gallery | null>(galleryPageQuery),
    staleTime: 1000 * 60 * 5,
  });
}
